import { computed, action, observable } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IContactDuplicate } from 'entities/Contacts/api/types'

export class RowContactDuplicate extends RowBase<IContactDuplicate> {
  private _count = 0

  constructor(origin: IContactDuplicate) {
    super(origin)

    this._count = origin.count

    makeObservableRowBase(this, {
      _count: observable,
      count: computed,
      setCount: action,
    })
  }

  get count() {
    return this._count
  }

  setCount = (count: number) => {
    this._count = count
  }
}
